import { SomaPopoverContent } from '@soma/react';
import Dialog, { DialogHeader, DialogContent } from 'xpi-black-ui/Common/Dialog';
import Text from 'xpi-black-ui/Base/Typography/Text';
import styled from 'styled-components';

const WrapperDialog = styled(Dialog).attrs(() => ({ height: 'auto', width: '950px' }))``;
export default WrapperDialog;

export const WrapperHeader = styled(DialogHeader)`
  height: 50px;
  padding: 15px 25px;

  i {
    top: 20px;
  }
`;

export const WrapperDialogContent = styled(DialogContent)`
  display: flex;
  background-color: #3F4147;
`;

export const WrapperDialogContentSeparator = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const WrapperDialogContentLegs = styled.div`
  margin-right: 0.8rem;
  padding: 0 1rem 0 0.5rem;
  overflow-y: auto;
  width: 65%;
  height: 380px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  border-right: 2px #FFC200 dashed;
`;

export const WrapperDialogContentInformation = styled.div`
  padding: 0 1rem 0 0.5rem;
  overflow-y: auto;
  width: 65%;
  height: 380px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.25rem;
`;

export const WrapperPositionInformation = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ isFullWidth }) => isFullWidth ? '100%' : '49%'};
`;

export const WrapperUnwindingInformation = styled.div`
  display: flex;
  width: ${({ isFullWidth }) => isFullWidth ? '50%' : '30%'};
`;

export const WrapperLegInformation = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1rem;
`;

export const WrapperSection = styled.section`
  display: flex;
`;

export const WrapperFooter = styled.footer`
  display: flex;
  flex-direction: column;
`;

export const WrapperSomaPopoverContent = styled(SomaPopoverContent)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AcceptTermButton = styled(Text).attrs(({ title: true }))`
  color: #FFC200;

  &:hover {
    cursor: pointer;
    font-weight: bold;
  }
`;

export const WrapperLegInfo = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: baseline;
`;

export const WrapperFooterContent = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 0.35rem;
`;

export const WrapperFooterInfo = styled.span`
  display: flex;
  margin-top: 20px;
  align-items: center;
  margin-bottom: -10px;
`;
